import { DROPDOWN_HEIGHT } from './constants';

const styles = theme => ({
  container: {
    position: 'relative',
    display: 'block',
    width: '100%',
    height: 'max-content',
  },
  requiredRed: {
    '& span:last-child': {
      color: theme.palette.primary.darkErrorRed,
    },
  },
  label: {
    marginBottom: '4px',
    fontWeight: 500,
    fontSize: '12px',
    color: '#130F26',
    [theme.breakpoints.up('sm')]: {
      fontSize: '14px',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '16px',
    },
  },
  select: {
    background: theme.palette.primary.white,
    color: theme.palette.primary.darkGrey,
    border: '1px solid #CED1D6',
    borderRadius: '0px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '11.5px 14px',
    transition: 'all 0.2s',
    '& p': {
      fontSize: '12px',
      marginRight: '5px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      // maxWidth: '95px',
      [theme.breakpoints.down('xs')]: {
        maxWidth: '220px',
      },
    },
    '&:hover': {
      boxShadow: '1px 1px 4px rgba(0, 0, 0, 0.3)',
    },
    [theme.breakpoints.up('sm')]: {
      padding: '13px 14px',
      '& p': {
        fontSize: '14px',
      },
    },
    [theme.breakpoints.up('md')]: {
      padding: '14px',
      '& p': {
        fontSize: '16px',
      },
    },
  },
  disabledSelect: {
    cursor: 'not-allowed',
    background: theme.palette.primary.borderColor,
    borderColor: '#D5D6D7',
    '& p': {
      color: '#828488',
    },
    '&:hover': {
      boxShadow: 'none',
    },
  },
  errorSelect: {
    border: '1px solid #EA4633',
  },
  errorMsg: {
    color: theme.palette.primary.errorRed,
    fontSize: '20px',
    [theme.breakpoints.up('sm')]: {
      fontSize: '14px',
    },
  },
  inFocus: {
    border: '1px solid #342D3D',
    boxShadow: '1px 1px 4px rgba(0, 0, 0, 0.3)',
    '&:focus': {
      outline: 'none',
      border: '1px solid #342D3D !important',
    },
  },
  selected: {
    color: theme.palette.secondary.main,
  },
  dropdownContainer: {
    position: 'absolute',
    // left: 0,
    width: '100%',
    minWidth: 'max-content',
    background: '#fff',
    marginTop: '4px',
    boxShadow: '1px 2px 10px rgba(0, 0, 0, 0.3)',
    zIndex: 1254,
  },
  dropdownContainerError: {
    top: '80%',
  },
  listContainer: {
    maxHeight: `${DROPDOWN_HEIGHT}px`,
    borderRadius: '0px',
    overflowY: 'auto',
    background: '#fff',
    minWidth: '100px',

    '&::-webkit-scrollbar': {
      width: '10px',
    },
    '&::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0px 0px 20px #ededed',
      borderRadius: '0px',
    },
    '&::-webkit-scrollbar-thumb': {
      '-webkit-box-shadow': 'inset 0px 0px 20px #CED1D6',
      borderRadius: '0px',
    },
    '& ul': {
      listStyleType: 'none',
      margin: '0px',
      padding: '0px',

      '& li': {
        '& > div': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '12px',
          color: theme.palette.secondary.main,
          padding: '14px',
          borderBottom: '1px solid #EBEEF3',
          cursor: 'pointer',
          '& p': {
            fontSize: '14px',
          },
          '&:hover': {
            background: theme.palette.primary.grey,
          },
          '&:focus': {
            outline: 'none',
            background: theme.palette.primary.grey,
          },
        },
        '&:last-child': {
          '& > div': {
            borderBottom: 'none',
          },
        },
      },
    },
  },
  listContainerMargin: {
    margin: '8px 6px 8px 0px',
  },
  listItem: {
    '& p': {
      fontSize: '12px !important',
      lineHeight: '18px !important',
      [theme.breakpoints.up('sm')]: {
        fontSize: '14px !important',
        fontWeight: '400 !important',
        lineHeight: '21px !important',
      },
    },
  },
  selectedItem: {
    background: theme.palette.primary.white,
    '& p': {
      color: '#0088FF',
      fontWeight: '600 !important',
    },
    // '&:hover': {
    //   background: theme.palette.primary.darkerGrey + '!important',
    // },
    // '&:focus': {
    //   outline: 'none',
    //   color: theme.palette.primary.white,
    //   background: theme.palette.primary.darkerGrey + '!important',
    // },
  },

  listContainerMulti: {
    '& $selectedItem': {
      background: `#0088FF!important`,
      '& p': {
        color: `${theme.palette.primary.adgmBlack} !important`,
        fontWeight: '400 !important',
      },
    },
  },
  searchContainer: {
    background: 'white',
    padding: '16px',
    paddingBottom: '0px',
    '& img': {
      marginRight: '10px',
      width: 20,
      height: 20,
    },
    marginBottom: '6px',
  },
  searchIcon: {
    color: theme.palette.primary.main,
  },
  searchInput: {
    width: 'auto',
    border: 'none',
    height: '40px',
    borderBottom: '1px solid #8C9099',
    fontSize: '14px',

    '&:focus-visible': {
      outline: 'none',
      borderBottom: '1px solid #342D3D',
    },
  },
  buttonsContainer: {
    padding: '1em 0.8em',
    textAlign: 'center',
    '& ul': {
      display: 'grid',
      gridTemplateColumns: 'auto auto auto auto auto',
      gap: '9px',
      '& li': {
        '& > div': {
          border: '1px solid #1FCACC',
          borderRadius: '0px',
          padding: '0.4em 0.8em',
        },
        '&:last-child': {
          '& > div': {
            borderBottom: '1px solid #1FCACC',
          },
        },
      },
    },
  },
  selectedButton: {
    background: theme.palette.primary.white,
    // '& > p': {
    //   color: theme.palette.primary.adgmGreen,
    //   fontWeight: '600 !important',
    // },
    // '&:hover': {
    //   borderColor: theme.palette.primary.darkerGrey + '!important',
    //   background: theme.palette.primary.darkerGrey + '!important',
    // },
  },
  radioContainer: {
    padding: '0.5em 1em',
  },
  radio: {
    '& label span': {
      fontSize: '14px',
    },
    '& input': {
      '&:checked + div': {
        color: '#1FCACC',
      },
    },
  },

  itemCheckbox: {
    width: '16px',
    height: '16px',
    borderRadius: '0px',
    background: theme.palette.primary.white,
    border: `2px solid ${theme.palette.primary.adgmBlack} !important`,
    padding: 0,
    position: 'relative',
    '&::before': {
      content: '""',
      width: '9px',
      height: '5px',
      position: 'absolute',
      top: '40%',
      left: '50%',
      transform: 'translate(-50%, -40%) rotate(-45deg)',
      borderBottom: `2px solid ${theme.palette.primary.lightADGMGreen}`,
      borderLeft: `2px solid ${theme.palette.primary.lightADGMGreen}`,
      display: 'none',
    },
    '& .MuiIconButton-label': {
      padding: 0,
    },
    '& svg': {
      display: 'none !important',
    },
  },
  itemCheckboxChecked: {
    border: `2px solid ${theme.palette.primary.main} !important`,
    '&::before': {
      display: 'inline-block',
    },
    // background: `${theme.palette.primary.adgmGreen} !important`,
    // border: `1px solid ${theme.palette.primary.adgmGreen} !important`,
  },

  '@media (max-width: 402px)': {
    dropdownContainer: {
      minWidth: '130%',
      maxWidth: 'max-content',
    },
    listContainer: {
      '&::-webkit-scrollbar': {
        width: '4px',
      },
    },
    searchContainer: {
      padding: '10px',
    },
    searchInput: {
      width: '75%',
    },
    buttonsContainer: {
      '& ul': {
        display: 'grid',
        gridTemplateColumns: 'auto',
        gap: '9px',
      },
    },
  },
  hintText: {
    marginTop: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    color: theme.palette.secondary.placeHolder,
    fontSize: '14px',
  },
});

export default styles;
